module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "choice form-group"
  }, [_c('a', {
    class: {
      'btn-secondary': _vm.type == 'match'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.type = 'match'
      }
    }
  }, [_vm._v("\n                Freies Spiel\n            ")]), _vm._v(" "), _c('a', {
    class: {
      'btn-secondary': _vm.type == 'tournament'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.type = 'tournament'
      }
    }
  }, [_vm._v("\n                Turnier\n            ")])]), _vm._v(" "), (_vm.type == 'match') ? _c('custom-form', {
    attrs: {
      "fields": [{
          name: 'opponent',
          title: 'Gegner',
          type: 'user',
          placeholder: 'Gegner suchen',
          userType: 'community',
          extractId: true
        },
        {
          name: 'num_games',
          title: 'Best of',
          type: 'toggle',
          choices: {
            1: 1,
            3: 3,
            5: 5,
            7: 7
          }
        } ],
      "submitLabel": "Erstellen",
      "url": "match/create"
    },
    on: {
      "input": _vm.onMatchInput,
      "submitted": _vm.onMatchCreated
    },
    model: {
      value: (_vm.match),
      callback: function($$v) {
        _vm.match = $$v
      },
      expression: "match"
    }
  }) : _c('custom-form', {
    attrs: {
      "fields": [{
          name: 'name',
          type: 'text',
          title: 'Name'
        },
        {
          name: 'invitees',
          title: 'Einladungen',
          type: 'user',
          userType: 'community',
          multiple: true,
          extractId: true
        },
        {
          name: 'num_players',
          title: 'Teilnehmer',
          type: 'number',
          min: 3
        },
        {
          name: 'num_games',
          title: 'Best of',
          type: 'toggle',
          choices: {
            1: 1,
            3: 3,
            5: 5,
            7: 7
          }
        } ],
      "submitLabel": "Erstellen",
      "url": "tournament/create"
    },
    on: {
      "submitted": _vm.onTournamentCreated
    },
    model: {
      value: (_vm.tournament),
      callback: function($$v) {
        _vm.tournament = $$v
      },
      expression: "tournament"
    }
  })], 1), _vm._v(" "), (_vm.type == 'match' && _vm.match.opponent) ? _c('section', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Elo-Vergleich")]), _vm._v(" "), _c('elo-chart', {
    attrs: {
      "matches": _vm.matches_me,
      "matchesB": _vm.matches_other,
      "userId": _vm.user.id,
      "userBId": _vm.match.opponent.id
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h1', [_vm._v("Spiele veranstalten")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61d07212","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/match.vue
// module id = 231
// module chunks = 0